module.exports = __webpack_public_path__ + "static/media/facebook.58b47089.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/UnifiedMessaging/facebook.svg
// module id = 1848
// module chunks = 0